import { useCallback, useEffect, useSyncExternalStore } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@helpers/translate";
import { ALERT } from "../../../../../../constants";
import {
  getFavoritePairs,
  loadFavoritePairs,
  removeFavoritePair,
  sameSlug,
  subscribeFavoritePairs,
  toggleFavoritePair,
} from "./favoritePairsStore";

/**
 * Favorite pairs shared between the asset modal and the quote header.
 */
export const useFavoritePairs = () => {
  const dispatch = useDispatch();
  const { __ } = useTranslation();
  const userId = useSelector((state) => state.user.user?.id);
  const favorites = useSyncExternalStore(
    subscribeFavoritePairs,
    getFavoritePairs,
  );

  useEffect(() => {
    loadFavoritePairs(userId);
  }, [userId]);

  const isFavorite = useCallback(
    (slug) => favorites.some((pair) => sameSlug(pair.slug, slug)),
    [favorites],
  );

  const showError = () => {
    dispatch({ type: ALERT.ALERT_ERROR, payload: __("common.error") });
  };

  return {
    favorites,
    isFavorite,
    toggleFavorite: (pair) => toggleFavoritePair(pair).catch(showError),
    removeFavorite: (slug) => removeFavoritePair(slug).catch(showError),
  };
};
